module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANBAMAAABfi4NQAAAAG1BMVEUAAACYmJiXl5ebm5uXl5eWlpaZmZmXl5eZmZmvhVh0AAAACHRSTlMAoIB/YHBQQDbOYZ4AAABMSURBVAjXY2BPYIAAFgcGj2Yo26KFIaLDAMxk7GgBYoiERIcCiDAACzeByWaYMFgCIgyRgAhDJAxBwlCJDpAwVAIkDJMACsOBC5gEAE54Ew1aYP1KAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ../src/component/post-item/img/icon-arrow-bottom.png
// module id = 837
// module chunks = 0 1